import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Card } from 'components/core/Card';
import { Button } from 'components/core/Button';
import { ReviewChart } from 'components/reviewV2/ReviewChart';
import Star from '../../svg/Star';
import ThumbsUp from '../../svg/ThumbsUp';
import { Checkbox } from '@sparefoot/react-core';
import { ChevronDown } from 'components/svg';

import ProsCons from './ProsCons';
import { Paragraph,Text } from 'components/core/Typography';

import './reviewSummary.scss';
import { formatRatingsSummary } from '../../../utils/rating';

const proConShape = PropTypes.shape({
	name: PropTypes.string.isRequired,
	reviewCount: PropTypes.number.isRequired
});

export function ReviewSummary({
	className,
	ratingCounts,
	totalReviews,
	pros,
	facilityId,
	reviewAverage
}) {
	const [toggle, setToggle] = useState(false);
	const toggleCheckbox = () => {
		setToggle(!toggle);
	}
	return (
		<div className={classnames(className, 'review-summary')}>
			{
				totalReviews > 0 && <Card hideBorder>
					<>
						<label className="accordion-menu">
							<div className="summary-header">
								<div>
									<span>
										<ChevronDown className="chevron-down" />
									</span>
									<Text size="small" weight="ultraBold">SpareFoot Reviews</Text>
									<Text size="small" weight="standard" className="review-count">{` (${totalReviews})`}</Text>
								</div>
								<div className="review-ratings">
									<div className="review-number">
										<Text size="small" weight="ultraBold">{formatRatingsSummary(reviewAverage)}</Text>
									</div>
									<div className="review-star">
										<Star
											value={1}
											size="medium"
										/>
									</div>
								</div>
								<Checkbox
									id={`review-summary-checkbox-${facilityId}`}
									onChange={toggleCheckbox}
									className="visually-hidden"
									checked={toggle}
								/>
							</div>
						</label>
						{!!totalReviews && (
							<div className="summary-content">
								<div className="rating-title">
									<Paragraph weight="ultraBold" size="smaller">RATINGS</Paragraph>
								</div>
								<ReviewChart
									ratingCounts={ratingCounts}
									totalReviews={totalReviews}
								/>
								<div className="rating-title">
									<Paragraph weight="ultraBold" size="smaller">QUALITIES</Paragraph>
								</div>
								<div>
									<ProsCons
										name="Pros"
										list={pros}
									/>
								</div>
								<Button
									fullWidth
									className="leave-review-button"
									href={`/review.html?fid=${facilityId}`}
									rel="nofollow"
								>
									<div><ThumbsUp/></div>
									<Paragraph size="small" weight="ultraBold">Leave a review</Paragraph>
								</Button>
							</div>
						)}
					</>
				</Card>
			}
		</div>
	);
}

ReviewSummary.propTypes = {
	className: PropTypes.string,
	pros: PropTypes.arrayOf(proConShape),
	cons: PropTypes.arrayOf(proConShape),
	ratingCounts: PropTypes.arrayOf(PropTypes.shape({
		rating: PropTypes.number.isRequired,
		count: PropTypes.number.isRequired
	})).isRequired,
	totalReviews: PropTypes.number.isRequired,
	facilityId: PropTypes.number.isRequired,
	recommendedRate: PropTypes.number
};

ReviewSummary.defaultProps = {
	pros: [],
	cons: []
};

export default ReviewSummary;
